function getPathFromId(id){
  return id.split('_').slice(1).join('.');
}

export default getPathFromId;